import React from "react";
import { Link } from "react-router-dom";

const AboutUs = () => {
  return (
    <section className="about-us-section fix section-padding pb-0">
      <div className="about-wrapper style1">
        
        <div className="shape1 d-none d-xxl-block">
          <img src="assets/img/shape/left.jpg" alt="shape" />
        </div>

        <div className="shape2 d-none d-xxl-block">
          <img src="assets/img/shape/aboutShape1_2.png" alt="shape" />
        </div>

        <div className="shape3 d-none d-xxl-block">
          <img
            className="cir36 rounded-circle" 
            src="assets/img/shape/Dish1.png"
            alt="shape"
          />
        </div>

        <div className="shape4 d-none d-xxl-block">
          <img src="assets/img/shape/right.jpg" alt="shape" />
        </div>

        <div className="shape5 d-none d-xxl-block">
          <img src="assets/img/shape/aboutShape1_5.png" alt="shape" />
        </div>

        <div className="shape6 d-none d-xxl-block"> 
          <img
            className="cir36 rounded-circle"
            src="assets/img/shape/Dish2.png"
            alt="shape"
          />
        </div>

        <div className="container">
          <div className="about-us section-padding">
            <div className="row">
              <div className="col-12">
                <div className="title-area">
                  
                  <div
                    className="sub-title text-center wow fadeInUp"
                    data-wow-delay="0.5s"
                  >
                    <img
                      className="me-1"
                      src="assets/img/icon/titleIcon.svg"
                      alt="icon"
                    />
                    About US
                    <img
                      className="ms-1"
                      src="assets/img/icon/titleIcon.svg"
                      alt="icon"
                    />
                  </div>

                  <h2
                    className="title wow fadeInUp"
                    data-wow-delay="0.7s"
                  >
                   The Spice Root – Premium Catering & Event Services in Ahmedabad
                  </h2>

                  <div
                    className="text wow fadeInUp"
                    data-wow-delay="0.8s"
                  >
                    The Spice Root specializes in premium catering for weddings, baby showers and events with customized menus,
                     live counters and 15+ years of trusted experience.
                  </div>

                  <div
                    className="btn-wrapper wow fadeInUp"
                    data-wow-delay="0.9s"
                  >
                    <Link className="theme-btn" to="/about">
                      Know More{" "}
                      <i className="fa-sharp fa-regular fa-arrow-right"></i>
                    </Link>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutUs;
